import { render, staticRenderFns } from "./ImageSettings.vue?vue&type=template&id=0c96baa2&"
import script from "./ImageSettings.vue?vue&type=script&lang=js&"
export * from "./ImageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports